module.exports = __webpack_public_path__ + "img/TheOldWall-800-450.19df8606.jpg";